export default "__VITE_ASSET__Bk86l9Ze__"